// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    marginTop: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down(1800)]: {
      marginTop: 50,
    },
    [theme.breakpoints.down(1600)]: {
      marginTop: 14,
    },
    [theme.breakpoints.down(769)]: {
      marginTop: 40,
    },
  },
  titleContainer: {
    maxWidth: 1150,
    width: '100%',
    [theme.breakpoints.down(1800)]: {
      width: '72%',
    },
    [theme.breakpoints.down(1600)]: {
      width: '63%',
    },
    [theme.breakpoints.down(1025)]: {
      width: '75%',
    },
    [theme.breakpoints.down(900)]: {
      width: '100%',
    },
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0',
    [theme.breakpoints.down(500)]: {
      margin: '6px 0 14px',
    },
  },
  playImageContainer: {
    marginRight: 30,
    [theme.breakpoints.down(1800)]: {
      marginRight: 25,
    },
    [theme.breakpoints.down(1600)]: {
      marginRight: 20,
    },
    [theme.breakpoints.down(1368)]: {
      marginRight: 15,
    },
    [theme.breakpoints.down(500)]: {
      marginRight: 10,
    },
  },
  playerContainer: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 1120,
    height: 650,
    width: '100%',
    [theme.breakpoints.down(1800)]: {
      width: '90%',
      height: 585,
    },
    [theme.breakpoints.down(1600)]: {
      width: '80%',
      height: 552,
    },
    [theme.breakpoints.down(1368)]: {
      width: '70%',
      height: 520,
    },
    [theme.breakpoints.down(1025)]: {
      maxWidth: '100%',
      width: '90%',
      height: 500,
    },
    [theme.breakpoints.down(769)]: {
      width: '95%',
      height: 450,
    },
    [theme.breakpoints.down(500)]: {
      width: '100%',
      height: 240,
    },
  },
  titleText: {
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_EXTRA_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_BOLD,
    [theme.breakpoints.down(1800)]: {
      fontSize: 42,
    },
    [theme.breakpoints.down(1600)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE
    },
  },
  descriptionText: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_EXTRA_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    [theme.breakpoints.down(1800)]: {
      fontSize: 42,
    },
    [theme.breakpoints.down(1600)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE
    },
  },
  playImage: {
    width: 86,
    [theme.breakpoints.down(1800)]: {
      width: 72,
    },
    [theme.breakpoints.down(1600)]: {
      width: 64,
    },
    [theme.breakpoints.down(1368)]: {
      width: 52,
    },
    [theme.breakpoints.down(500)]: {
      width: 43,
    },
  },
});

export default styles;
